import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { D_INV22G, DISPLAY, TOKEN, USER } from "constants/api/localStorage";
import { ResponseTypes } from "constants/api/ResponseTypes";
import { RequestToSend } from "models/RequestToSend";
import { connectionApi } from "services/api/connectionApi";
import { getLocalStorageOrCookie } from "utils/getLocalStorageOrCookie";

interface NotificationsMessage {
  message: string;
  code: ResponseTypes;
  id: number;
}

interface ButtonsState {
  productView: boolean;
  storeView: boolean;
}

type appState = {
  appState: string;
  token: string;
  user: string;
  notificationMessages: NotificationsMessage[];
  loadingRequests: string[];
  confirmData: Array<{
    code: string;
    message: string;
    method: string | undefined;
    body: unknown;
    url: string;
  }>;
  buttonsState: ButtonsState;
  headerExpanded: boolean;
  sectionHeaderExpanded: boolean;
  d_inv22g: any;
  modalsOpened: string[];
  requestsInQueue: RequestToSend[];
};

const initialState: appState = {
  appState: "",
  token:
    getLocalStorageOrCookie(TOKEN) !== undefined
      ? getLocalStorageOrCookie(TOKEN)!
      : "",
  user:
    getLocalStorageOrCookie(USER) !== undefined
      ? getLocalStorageOrCookie(USER)!
      : "",
  notificationMessages: [],
  loadingRequests: [],
  confirmData: [],
  buttonsState: localStorage.getItem(DISPLAY)
    ? JSON.parse(localStorage.getItem(DISPLAY)!)
    : { productView: true, storeView: false },
  headerExpanded: false,
  sectionHeaderExpanded: false,
  d_inv22g: localStorage.getItem(D_INV22G)
    ? JSON.parse(localStorage.getItem(D_INV22G)!)
    : {},
  modalsOpened: [],
  requestsInQueue: [],
};

export const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setAppState: (state, action: PayloadAction<string>) => {
      state.appState = action.payload;
    },

    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      localStorage.setItem(TOKEN, action.payload);
    },

    setUser: (state, action: PayloadAction<string>) => {
      state.user = action.payload;
    },

    logout: state => {
      localStorage.clear();
      state.token = "";
      connectionApi.util.resetApiState();
    },

    addLoadingRequest: (state, action) => {
      state.loadingRequests.push(action.payload);
    },

    removeLoadingRequest: (state, action) => {
      const index = state.loadingRequests.indexOf(action.payload);
      state.loadingRequests.splice(index, 1);
    },

    setButtonsState: (state, action: PayloadAction<ButtonsState>) => {
      localStorage.setItem(DISPLAY, JSON.stringify(action.payload));
      state.buttonsState = action.payload;
    },

    setd_inv22g: (state, action) => {
      state.d_inv22g = action.payload;
      localStorage.setItem(D_INV22G, JSON.stringify(action.payload));
    },
  },
});

export const {
  setAppState,
  setToken,
  setUser,
  logout,
  setd_inv22g,
  addLoadingRequest,
  removeLoadingRequest,
} = appStateSlice.actions;

export default appStateSlice.reducer;
